import Vue from "vue";
import Router from "vue-router";

import HomePage from "@/components/pages/home/home.page.vue";
import NewsPage from "@/components/pages/news/news.page.vue";
import SuggestionsPage from "@/components/pages/suggestions/suggestions.page.vue";
import ArticlePage from "@/components/pages/article/article.page.vue";
import ContactsPage from "@/components/pages/contacts/contacts.page.vue";
import AboutPage from "@/components/pages/about/about.page.vue";
import ExhibitionPage from "@/components/pages/exhibition/exhibition.page.vue";
import PublicationPage from "@/components/pages/publication/publication.page.vue";
import ArchivePage from "@/components/pages/archive/archive.page.vue";
import PublicationsPage from "@/components/pages/publications/publications.page.vue";
import ErrorPage from "@/components/pages/error/error.page.vue";

import PlaygroundPage from "@/components/pages/playground/playground.page.vue";

Vue.use(Router);

export default new Router({
	mode: "history",
	routes: [
		{
			path: "/",
			redirect: "/pt",
		},
		{
			path: "/:lang",
			component: HomePage,
			name: "HomePage",
		},
		{
			path: "/:lang/about",
			component: AboutPage,
			name: "AboutPage",
		},
		{
			path: "/:lang/suggestions",
			component: SuggestionsPage,
			name: "SuggestionsPage",
			children: [
				{
					path: "/:lang/suggestions/:suggestion",
					component: SuggestionsPage,
					name: "SuggestionsPage",
				}
			]
		},
		{
			path: "/:lang/news",
			component: NewsPage,
			name: "NewsPage",
			children: [
				{
					path: "/:lang/news/:article",
					component: NewsPage,
					name: "NewsPage",
				}
			]
		},
		{
			path: "/:lang/exhibitions/:exhibition",
			component: ExhibitionPage,
			name: "ExhibitionPage",
		},
		{
			path: "/:lang/publications",
			component: PublicationsPage,
			name: "PublicationsPage",
		},
		{
			path: "/:lang/publications/:publication",
			component: PublicationPage,
			name: "PublicationPage",
		},
		{
			path: "/:lang/archive",
			component: ArchivePage,
			name: "ArchivePage",
		},
		{
			path: "/:lang/**",
			component: ErrorPage,
			name: "ErrorPage",
		},
	]
})



// WEBPACK FOOTER //
// ./src/router.js